import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		navLinks: {}
	},
	getters: {
		navLinks: state => {
			return state.navLinks
		}
	},
	mutations: {
		setNavLinks (state, payload) {
			state.navLinks = payload
		}
	},
	actions: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js